export const listConstant = {
  childHeader: 'PROCESS & PRODUCT AUDIT',
  addButtonLable: 'NEW PROCESS & PRODUCT AUDIT',
  datePickerLabel: 'Search By Year',
  modalTile: 'CREATE NEW PROCESS & PRODUCT AUDIT',
};

export const createConstant = {
  childHeader: 'PROCESS & PRODUCT AUDIT PLAN',
  theadHeader: 'PROCESS & PRODUCT AUDIT PLAN',
  extracolSpan: 3,
};

export const checkListList = {
  childHeader: 'PROCESS & PRODUCT AUDIT PLAN STATUS',
  addButtonLable: '',
  datePickerLabel: 'Search By Year',
  modalTile: 'UPDATE STATUS',
};

export const apiConstant = {
  deleteurl: 'productAuditPlanRoute',
  gettableDataurl: 'productAuditPlanRoute/monthly',
  getPlanByid: 'productAuditPlanRoute',
  createPlanByid: 'productAuditPlanRoute',
  updatePlanByid: 'productAuditPlanRoute',
  sync: 'productAuditPlanRoute/handleSync',
  getAllCheckList: 'productAuditPlanRoute/getAllCheckList',
  checkListStatus: 'productAuditPlanRoute/handleStatus',
  checklistUpload: 'productAuditPlanRoute/handleUpload',
  checklistDeleteImage: 'productAuditPlanRoute/handleDeleteImage',
  checklistData: 'productAuditPlanRoute/checklistRoute',
};

export const navigationConstant = {
  createPlanSchedule: '/common/productAuditPlanCreate',
  createChecklist: '/common/productAuditPlanChecklistCreate',
};
